<script setup>
  // import { useClubRouter } from '@/features/router/useClubRouer.js'

  // console.log('getRoutes -->', useClubRouter().getRoutes())
</script>

<template>
  <div class="not-found">
    <div class="container">
      <div class="error-code">404</div>
      <h1 class="title">Page Not Found</h1>
      <p class="description">Oops! The page you're looking for doesn't exist or has been moved.</p>
      <RouterLink to="/" class="home-button">
        <Button severity="secondary" size="large" aria-label="Go to Home">Go to Home</Button>
      </RouterLink>
    </div>
  </div>
</template>

<style scoped>
  .not-found {
    min-height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(135deg, #1e2a78, #2a4f98);
    font-family:
      system-ui,
      -apple-system,
      sans-serif;
  }

  .container {
    text-align: center;
    color: light-dark(#ffffff, #e0e0e0);
    padding: 2rem;
  }

  .error-code {
    font-size: 5rem;
    font-weight: 700;
    text-shadow: 4px 4px 0 rgba(0, 0, 0, 0.2);
    animation: float 6s ease-in-out infinite;
  }

  .title {
    font-size: 2rem;
    margin: 2rem 0;
    font-weight: 600;
    text-shadow: 2px 2px 0 rgba(0, 0, 0, 0.2);
  }

  .description {
    font-size: 1.2rem;
    margin-bottom: 3rem;
    opacity: 0.8;
  }

  @keyframes float {
    0%,
    100% {
      transform: translateY(0);
    }
    50% {
      transform: translateY(-20px);
    }
  }

  @media (max-width: 768px) {
    .error-code {
      font-size: 8rem;
    }

    .title {
      font-size: 2rem;
    }

    .description {
      font-size: 1.2rem;
    }
  }
</style>
